import { Step } from 'react-joyride';

import { pagePaths } from 'config/pages';

import CalenderIconDisabled from '../assets/icons/calendar-icon-disable.png';
import CalenderIcon from '../assets/icons/calendar-icon.png';
import ListIconActive from '../assets/icons/list-bullet-active.png';
import ListIcon from '../assets/icons/list-bullet.png';

export const ALL_APPOINTMENT_COLORS: { [index: string]: string } = {
  EXTRACTION: '#C4FDFD',
  FITTING: '#D5EAFF',
  IPR: '#C4FDFD',
  SCAN: '#C4FDFD',
  RE_SCAN: '#C4FDFD',
  RE_CHECK: '#C4FDFD',
  MID_REVIEW: '#C4FDFD',
  FINAL_REVIEW: '#C4FDFD',
  CONSULTATION: '#FFE3EF',
  FOLLOW_UP: '#C4FDFD',
  DEFAULT: '#2CAAE2',
  APPOINTMENT_TEXT_COLOR: '#282829',
  NO_SHOW_BG: '#FFEEF0',
  NO_SHOW_TEXT: '#D91E36',
  ADD_ATTACHMENT: '#C4FDFD',
  REMOVE_ATTACHMENT: '#C4FDFD',
  ADD_BUTTON: '#C4FDFD',
  REMOVE_BUTTON: '#C4FDFD',
  WHITENING_CONSULTATION: '#FFE3EF',
  PERSONAL: '#D5EAFF'
};

export const APPOINTMENT_TYPES: Record<string, string> = {
  FOLLOW_UP: 'Follow Up',
  FITTING: 'Fitting',
  CONSULTATION: 'Consultation',
  EXTRACTION: 'Extraction',
  IPR: 'IPR',
  SCAN: 'Scan',
  RE_SCAN: 'Re-scan',
  RE_CHECK: 'Re-check',
  MID_REVIEW: 'Mid-treatment review',
  FINAL_REVIEW: 'End-of-treatment review',
  ADD_ATTACHMENT: 'Add attachment',
  REMOVE_ATTACHMENT: 'Remove attachment',
  ADD_BUTTON: 'Add button',
  REMOVE_BUTTON: 'Remove button',
  WHITENING_CONSULTATION: 'Whitening consultation',
  PERSONAL: 'Personal'
};

export const EDIT_DISABLED_FIELDS = {
  patient: true,
  remarks: true,
  clinic: true
};

export const EVENT_STATUS: Record<string, string> = {
  SHOWED_UP: 'showed up',
  NO_SHOW: 'no show'
};

export const CHECK_FOR_APPT_TYPE: Record<string, string> = {
  CONSULTATION: 'CONSULTATION'
};

export const EDIT_EVENT_BREADCRUMBS = [
  {
    label: 'dashboard_button.dashboard',
    pathname: pagePaths?.dashboard
  },
  {
    label: 'calendar_button.calendar',
    pathname: pagePaths?.calendar
  },
  {
    label: 'calendar.reschedule'
  }
];

export const CREATE_EVENT_BREADCRUMBS = [
  {
    label: 'dashboard_button.dashboard',
    pathname: pagePaths?.dashboard
  },
  {
    label: 'calendar_button.calendar',
    pathname: pagePaths?.calendar
  },
  {
    label: 'chips_label.create_new'
  }
];

export enum OUTCOME_BACKEND {
  SUCCESS = 'SUCCESS',
  ILL_FITTING_AT_FITTING = 'ILL_FITTING_AT_FITTING',
  OTHER_ISSUES = 'OTHER_ISSUES'
}

export const OUTCOME: Record<string, string> = {
  [OUTCOME_BACKEND.SUCCESS]: 'Success',
  [OUTCOME_BACKEND.ILL_FITTING_AT_FITTING]: 'ill-Fitting',
  NOT_AVAILABLE: 'Not Available',
  [OUTCOME_BACKEND.OTHER_ISSUES]: 'Other Issues'
};

export const CALENDER_APPOINTMENT_OUTCOME_LIST = [
  {
    value: OUTCOME_BACKEND.SUCCESS,
    label: 'Success'
  },
  {
    value: OUTCOME_BACKEND.ILL_FITTING_AT_FITTING,
    label: 'ill-Fitting'
  },
  {
    value: OUTCOME_BACKEND.OTHER_ISSUES,
    label: 'Other Issues'
  },
  {
    value: 'NOT_AVAILABLE',
    label: 'Not Available'
  }
];

export const TREATMENT_TYPE_LIST = [
  {
    value: 'ZENCLEAR',
    label: 'ZenyumClear™'
  },
  {
    value: 'ZENCLEAR_PLUS',
    label: 'ZenyumClear™ Plus'
  },
  {
    value: 'ZENCLEAR_LITE',
    label: 'ZenyumClear™ Lite'
  },
  {
    value: 'RETAINER',
    label: 'Retainer'
  },
  {
    value: 'WHITENING',
    label: 'Whitening'
  }
];

export const TREATMENT_LIST = [
  {
    value: 'PRIMARY',
    label: 'sidepanel_appointmentlist.primary'
  },
  {
    value: 'REFINEMENT',
    label: 'refinement.refinement'
  },
  {
    value: 'RETAINER',
    label: 'Retainer'
  },
  {
    value: 'WHITENING',
    label: 'Whitening'
  }
];

export const TREATMENT_LIST_LABELS: Record<string, string> = {
  PRIMARY: 'sidepanel_appointmentlist.primary',
  REFINEMENT: 'refinement.refinement',
  RETAINER: 'Retainer',
  WHITENING: 'Whitening'
};

export const CALENDAR_GUIDE_STEPS = [
  {
    target: '#calendar-guide-step-2',
    disableBeacon: true,
    content: 'Click here to view appointments in a list.',
    placement: 'bottom'
  }
];

export const NAVBAR_GUIDE_STEPS: Step[] = [
  {
    target: '#sidebar-item-calendar',
    disableBeacon: true,
    content:
      "All your appointment information is now available under 'Calendar'.",
    placement: 'right'
  }
];

export const CALENDAR_CATEGORY_OPTIONS = [
  {
    buttonName: 'CALENDAR',
    label: 'Calendar view',
    img: CalenderIcon
  },
  { buttonName: 'LIST', label: 'List view', img: ListIcon }
];

export const APPOINTMENT_LIST_CATEGORY_OPTIONS = [
  {
    buttonName: 'CALENDAR',
    label: 'Calendar view',
    img: CalenderIconDisabled
  },
  { buttonName: 'LIST', label: 'List view', img: ListIconActive }
];
